import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from '../services/firebase';

export interface IEvent {
    id: number;
    type: "TYPING"
        | "SELECT_INSPECTOR" | "SELECT_INSPECTOR_ON" | "SELECT_INSPECTOR_OFF"
        | "ERROR_INSPECTOR"
        | "TASK_START" | "TASK_END"
        | "UNDO" | "REDO" | "RESET"
        | "STEP_CHANGE"
        | "HELP_OPENED"
        | "EXTEND_TIME";
    time: string;
    value: any;
}

export class EventService {
    public saveEvent(userId: string, taskId: string, event: IEvent): Promise<any> {
        return addDoc(collection(db, `users/${userId}/tasks/${taskId}/events`), event);
    }

    public getEvents(userId: string, taskId: string): Promise<any> {
        return getDocs(collection(db, `users/${userId}/tasks/${taskId}/events`)).then(eventSnapshot => {
            return eventSnapshot.docs.map(doc => doc.data()).sort((a, b) => {
                if (a.id > b.id) {
                    return 1;
                } else {
                    return -1;
                }
            });
        });
    }
}